exports.setup = function() {
    var _kiq = window._kiq || [];
    (function () {
        setTimeout(function () {
            var d = document, 
                f = d.getElementsByTagName('script')[0], 
                s = d.createElement('script'); 
            s.type = 'text/javascript';
            s.async = true; 
            s.src = '//s3.amazonaws.com/ki.js/59820/dro.js'; 
            f.parentNode.insertBefore(s, f);
        }, 1);
    })();
}


// WEBPACK FOOTER //
// ./src/scripts/onload/qualaroo.js